import React, { useState } from "react"
import Image from "next/image"
import { Box, Container, Grid, IconButton } from "@mui/material"
import { makeStyles } from "makeStyles"
import { SeriesModelLock } from "utils/commerceTools/formatters/formatSeries"

import DownloadItem from "containers/SeriesPage/BTF/DownloadItem"

const useStyles = makeStyles()(() => ({
	root: {
		position: "relative",
		zIndex: 1,
		marginTop: 100,
		marginBottom: 50,
	},
	textBoxStyle: {
		background: "#182F37",
		width: "100%",
		height: "100%",
		borderRadius: 5,
		position: "relative",
	},
	padding: {
		padding: "50px 0px 50px 100px",
		"@media only screen and (max-width: 960px)": {
			padding: "30px",
		},
	},
	image: {
		marginRight: -120,
		marginTop: 40,
		maxHeight: 400,
		zIndex: 1,
		position: "relative",
		"@media only screen and (max-width: 960px)": {
			display: "none",
		},
	},
	assetPosition: {
		position: "absolute",
		top: -20,
		right: -20,
		"@media only screen and (max-width: 960px)": {
			position: "relative",
			top: 0,
			right: 0,
		},
	},
	hideOnMobile: {
		display: "block",
		"@media only screen and (max-width: 960px)": {
			display: "none",
		},
	},
	hideOnDesktop: {
		display: "none",
		"@media only screen and (max-width: 960px)": {
			display: "block",
		},
	},
}))

const LockVariants = ({ locks, image }: Props) => {
	const { classes } = useStyles()

	const [activeLock, setActiveLock] = useState(locks[0])

	return (
		<Box mt={15} mb={10} style={{ position: "relative", zIndex: 1 }}>
			<Container>
				<h3 style={{ fontSize: 25, marginBottom: 50 }}>
					Bestens ausgerüstet mit diversen Schlossvarianten
				</h3>
				<Grid container spacing={3} className={classes.textBoxStyle}>
					<Grid item xs={12} md={2} style={{ position: "relative" }}>
						<div className={classes.image}>
							{image && (
								<Image
									alt="Schlossvarianten"
									src={image}
									width={400}
									height={400}
									style={{
										maxWidth: "100%",
										height: "auto",
										objectFit: "contain",
									}}
								/>
							)}
						</div>
					</Grid>
					<Grid item xs={12} md={10}>
						<div className={classes.padding}>
							<div className="h4">Schlossvarianten</div>
							{/* Show Lock Selection */}
							<Box my={4} style={{ display: "flex" }}>
								{locks.map((lock) => {
									const { id, name, images } = lock
									const img = images?.[0]
									return (
										<div key={id}>
											<IconButton
												style={{
													height: 70,
													width: 70,
													background: "rgba(0,0,0,0.2)",
													border:
														activeLock === lock
															? "2px solid #009CAC"
															: "none",
													padding: 0,
												}}
												onClick={() => setActiveLock(lock)}
												size="large"
											>
												<Image
													alt={name}
													src={img}
													width={60}
													height={60}
													style={{
														maxWidth: "100%",
														objectFit: "contain",
													}}
												/>
											</IconButton>
										</div>
									)
								})}
							</Box>
							{/* Desktop Assets */}
							<div className={classes.hideOnMobile}>
								<div className={classes.assetPosition}>
									{locks.map((lock, i) => {
										const { assets } = lock
										return (
											<div key={i}>
												{assets.map((asset) => {
													const { url } = asset
													return (
														<div key={i} style={{ marginBottom: 10 }}>
															{/* TODO: ASSET NAME */}
															<a
																href={url}
																target="_blank"
																rel="noopener noreferrer"
																style={{ textDecoration: "none" }}
															>
																<DownloadItem
																	title="Bedienunganleitung"
																	name={lock.name}
																/>
															</a>
														</div>
													)
												})}
											</div>
										)
									})}
								</div>
							</div>
							{/* Active Lock */}
							{activeLock && (
								<div>
									<div className="h4">{activeLock?.name}</div>
									<p
										dangerouslySetInnerHTML={{
											__html: activeLock?.shortDescription,
										}}
										style={{ marginTop: 20 }}
									/>
								</div>
							)}
							{/* Mobile Assets */}
							<div className={classes.hideOnDesktop}>
								<div className={classes.assetPosition}>
									{locks.map((lock, i) => {
										const { assets } = lock

										return (
											<div key={i}>
												{assets.map((asset) => {
													const { url } = asset
													return (
														<div key={i} style={{ marginBottom: 10 }}>
															{/* TODO: ASSET NAME */}
															<a
																href={url}
																target="_blank"
																rel="noopener noreferrer"
																style={{ textDecoration: "none" }}
															>
																<DownloadItem
																	title="Bedienunganleitung"
																	name={lock.name}
																/>
															</a>
														</div>
													)
												})}
											</div>
										)
									})}
								</div>
							</div>
						</div>
					</Grid>
				</Grid>
			</Container>
		</Box>
	)
}

interface Props {
	locks: SeriesModelLock[]
	image: string
}

export default LockVariants
